import Heading from './heading';
import Typography from './typography';
import Paragraph from './paragraph';
import Text from './text';
var DefaultTypo = Typography;
DefaultTypo.Heading = Heading;
DefaultTypo.Paragraph = Paragraph;
DefaultTypo.Text = Text;
export default DefaultTypo;
//# sourceMappingURL=index.js.map